let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9fF3I")).then(() => parcelRequire('d9jiN'));